import { buildModelManager } from "../builder.js";
const DefaultPublicEnquirySelection = {
  __typename: true,
  id: true,
  createdAt: true,
  fromEmail: true,
  fromName: true,
  fromPhone: true,
  fromPostcode: true,
  jobSummary: true,
  profileId: true,
  requestedServiceLabel: true,
  requestedSlotEnd: true,
  requestedSlotStart: true,
  sourceUrl: true,
  status: true,
  updatedAt: true,
  workItemId: true
};
const modelApiIdentifier = "publicEnquiry";
const pluralModelApiIdentifier = "publicEnquiries";
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPublicEnquirySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPublicEnquirySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPublicEnquirySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPublicEnquirySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPublicEnquirySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPublicEnquirySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPublicEnquirySelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPublicEnquiry",
    operationReturnType: "CreatePublicEnquiry",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      publicEnquiry: { required: false, type: "CreatePublicEnquiryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPublicEnquirySelection
  },
  {
    type: "action",
    operationName: "bulkCreatePublicEnquiries",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePublicEnquiriesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPublicEnquirySelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "publicEnquiryGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PublicEnquiryManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPublicEnquirySelection,
  operations
);
export {
  DefaultPublicEnquirySelection,
  PublicEnquiryManager
};
//# sourceMappingURL=PublicEnquiry.js.map
